/**
 * Analytics utility for tracking custom events.
 * Currently uses Google Analytics (gtag), but designed to be
 * easily extended to other analytics platforms in the future.
 */

type EventParams = Record<string, string | number | boolean | undefined>

/**
 * Track a custom event to analytics platforms.
 * Wrapped in try-catch to ensure it never affects app functionality.
 *
 * @param eventName - The name of the event to track
 * @param params - Optional parameters to send with the event
 */
export function trackEvent(eventName: string, params?: EventParams): void {
  try {
    // Google Analytics
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', eventName, params)
    }

    // Future analytics platforms can be added here:
    // if (window.mixpanel) { ... }
    // if (window.amplitude) { ... }
    // if (window.posthog) { ... }
  } catch {
    // Silently fail - analytics should never break the app
  }
}
